import { render } from "./AnnouncementTable.vue?vue&type=template&id=6be4a566&scoped=true&ts=true"
import script from "./AnnouncementTable.ts?vue&type=script&lang=ts"
export * from "./AnnouncementTable.ts?vue&type=script&lang=ts"

import "./AnnouncementTable.scss?vue&type=style&index=0&id=6be4a566&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be4a566"]])

export default __exports__